module.exports = {
  'young_child': { value: 'enum.age.youngChild', code: 'YC' },
  'child': { value: 'enum.age.child', code: 'C' },
  'teenager': { value: 'enum.age.teenager', code: 'T' },
  'adult': { value: 'enum.age.adult', code: 'A' }
}
